import { useEffect, useState } from "react";
import { customersAPI, StitchAPI, ordersAPI } from "../../services/api";


export default function AddStitchModal({ onClose, orderId, defaultCustomerId }) {
  const [customers, setCustomers] = useState([]);
  const [stitchTypes, setStitchTypes] = useState([]);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);

  const [form, setForm] = useState({
    customerId: defaultCustomerId || "",
    stitchType: "",
  });

  // 🔥 Load customers + stitch types
  useEffect(() => {
    const loadData = async () => {
      try {
        const [customersRes, stitchRes] = await Promise.all([
          customersAPI.list(),
          StitchAPI.get(),
        ]);

        setCustomers(Array.isArray(customersRes) ? customersRes : []);

        // normalize stitch types
        const stitches = (stitchRes?.stitchTypes || []).map((s) => ({
          id: s.PM_ID,
          name: s.PM_Name,
        }));

        setStitchTypes(stitches);

      } catch (e) {
        console.error(e);
        setApiError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const handleChange = (key) => (e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
    if (errors[key]) {
      setErrors((prev) => ({ ...prev, [key]: "" }));
    }
  };

  // 🔥 SAVE STITCH
  const handleSave = async () => {
    const e = {};

    if (!form.customerId) e.customerId = "Select customer";
    if (!form.stitchType) e.stitchType = "Select stitch type";

    if (Object.keys(e).length) {
      setErrors(e);
      return;
    }

    try {
      setSaving(true);

      const payload = {
        OSD_OM_ID: orderId,
        OSD_PM_ID: Number(form.stitchType),
        OSD_LM_ID: Number(form.customerId),
      };

      console.log("Saving Stitch:", payload);

      await ordersAPI.addStitch(payload);

      onClose();

    } catch (err) {
      console.error(err);
      setApiError("Failed to save stitch");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>

        {/* HEADER */}
        <div style={styles.header}>
          <h2 style={{ margin: 0 }}>➕ Add Stitch</h2>
          <button onClick={onClose} style={styles.closeBtn}>✕</button>
        </div>

        {/* ERROR */}
        {apiError && <div style={styles.error}>{apiError}</div>}

        {/* BODY */}
        {loading ? (
          <div style={styles.center}>Loading...</div>
        ) : (
          <div style={styles.body}>

            {/* CUSTOMER */}
            <div style={styles.field}>
              <label style={styles.label}>Customer *</label>
              <select
                style={styles.input}
                value={form.customerId}
                onChange={handleChange("customerId")}
              >
                <option value="">Select Customer</option>
                {customers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name} ({c.phone})
                  </option>
                ))}
              </select>
              {errors.customerId && <div style={styles.error}>{errors.customerId}</div>}
            </div>

            {/* STITCH TYPE */}
            <div style={styles.field}>
              <label style={styles.label}>Stitch Type *</label>
              <select
                style={styles.input}
                value={form.stitchType}
                onChange={handleChange("stitchType")}
              >
                <option value="">Select Stitch</option>
                {stitchTypes.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>
              {errors.stitchType && <div style={styles.error}>{errors.stitchType}</div>}
            </div>

          </div>
        )}

        {/* FOOTER */}
        <div style={styles.footer}>
          <button style={styles.cancelBtn} onClick={onClose}>
            Cancel
          </button>
          <button
            style={styles.saveBtn}
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>

      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    width: 420,
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    overflow: "hidden",
  },
  header: {
    padding: "16px 20px",
    borderBottom: "1px solid #eee",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  closeBtn: {
    border: "none",
    background: "transparent",
    fontSize: 18,
    cursor: "pointer",
  },
  body: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  field: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: 6,
    fontWeight: 500,
  },
  input: {
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #ccc",
    fontSize: 14,
  },
  footer: {
    padding: 16,
    borderTop: "1px solid #eee",
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
  },
  cancelBtn: {
    padding: "8px 16px",
    background: "#eee",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
  },
  saveBtn: {
    padding: "8px 16px",
    background: "#4caf7a",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
  },
  error: {
    color: "red",
    fontSize: 13,
    marginTop: 4,
  },
  center: {
    padding: 20,
    textAlign: "center",
  },
};